import { Injectable } from '@angular/core';
import { Platform, ActionSheetController, NavController, AlertController } from '@ionic/angular';
import { tempDynamicStoreconfig } from 'src/app/shared/tempDynamicStoreconfig';
import { AppService } from './app.service';
import { IdbService } from '../services/idb.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppEnum } from '../appenum';
import { BehaviorSubject } from 'rxjs';
import { EncryptionService } from './encryption.service';
import { environment } from 'src/environments/environment';
import { AppSettings } from '../app.settings';
import { LoggingService } from './logging.service';
import { AppNavigation } from './app-navigation';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root'
})
export class AsyncUtilityService {
  public retryDelay = 3000;
  public isdataSync = new BehaviorSubject(false);
  _UploadResponse: any;
  public componentName = 'Async-utility';
  private cacheName = 'blob-cache-v1';
  orgId: any;
  takenPhotoMessage: any;
  constructor(public _nav: AppNavigation,
    public _tempDynamicFormConfig: tempDynamicStoreconfig,
    public _appServices: AppService,
    public _appenum: AppEnum,
    public http: HttpClient,
    public idbservice: IdbService,
    public encryptionService: EncryptionService,
    public _appSetting: AppSettings,
    public loggingService: LoggingService,
    public alertCtrl: AlertController,
    public _translateService: TranslateService
  ) {
    wrapAllMethodsWithLogging(this, this.componentName);
    this.orgId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId))
  }

  async updateFormJson(InspectionFileDetails) {
    var fileTreeJson = this._appServices.get_filesDetails_audio_List(InspectionFileDetails);
    for (var i = 0; i < fileTreeJson.length; i++) {
      var setOfValue = [];
      var imageZoneDetails = this._tempDynamicFormConfig.isValidJson(fileTreeJson[i].zoneDetails) ? JSON.parse(fileTreeJson[i].zoneDetails) : "";
      if (imageZoneDetails && imageZoneDetails != "") {
        var clickedZone = this._tempDynamicFormConfig.getSelectedChildObject(imageZoneDetails.name, imageZoneDetails.parent, imageZoneDetails.controlName);

        if (this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.serverDataKeys[clickedZone.ZoneIndex]]) {
          if (this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.serverDataKeys[clickedZone.ZoneIndex]][0].data[clickedZone.indexOfSelectedCat].hasOwnProperty("value")) {
            var catValues = this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.serverDataKeys[clickedZone.ZoneIndex]][0].data[clickedZone.indexOfSelectedCat].value;
            var oldValues = this._tempDynamicFormConfig.isValidJson(catValues) ? JSON.parse(catValues) : [];
            setOfValue = oldValues.filter(item => item.FileName != fileTreeJson[i].FileName);
          }
          setOfValue.push(fileTreeJson[i]);
          // this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.serverDataKeys[clickedZone.ZoneIndex]][0].data[clickedZone.indexOfSelectedCat].value = setOfValue.length>0 ? JSON.stringify(setOfValue) : "";
          this._tempDynamicFormConfig.serverData[this._tempDynamicFormConfig.serverDataKeys[clickedZone.ZoneIndex]][0].data[clickedZone.indexOfSelectedCat].value = setOfValue.length > 0 ? JSON.stringify(setOfValue) : undefined;
        }
      }
    }
    // this.encryptionService.sessionstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.isRunningAsyncUtility, 'false')

  }

  async uploadTaskFiles(taskId: string): Promise<void> {
    try {
      const InspectionFileData: any[] = await this.idbservice.getTaskFileDetailsToUpload(
        taskId,
        this._appServices.UploadMaxRetryHit,
        this.orgId
      );
      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Info,
        `Fetched ${InspectionFileData.length} pending file(s) for taskId: ${taskId}`,
        this.componentName, null, null
      );

      if (InspectionFileData.length > 0) {
        this.encryptionService.sessionstorageEncrypt(
          this._appenum.EntityOfLocalStorageKeys.isRunningAsyncUtility, 'true'
        );
        await this.autoStartUpload(0, InspectionFileData, taskId, 1);
      } else {
        this.finalupdateFormJson(taskId);
      }
    } catch (err: any) {
      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Error,
        `uploadTaskFiles() failed for taskId: ${taskId}`,
        this.componentName,
        { error: err?.message || err },
        null,
        undefined,
        'uploadTaskFiles'
      );
    }
  }

  async autoStartUpload(
    index = 0,
    InspectionFileData: any[],
    taskId: string,
    hitCount = 1
  ): Promise<void> {
    const logContext = 'autoStartUpload()';
    const currentFile = InspectionFileData[index];
    console.log("currentFile", currentFile)
    this._appServices.logsActivity(
      this._appenum.EntityOfLogLevel.Info,
      `Starting upload — index: ${index}, file: ${currentFile?.fileName}, attempt: ${hitCount}`,
      this.componentName, null, null
    );

    try {
      await this.idbservice.fileStatusChange(currentFile, 'syncing');
      const isValidToken = await this._appServices.checkTokenExpired();
      console.log("isValidToken", isValidToken)
      // if (index === 0) currentFile.LocalFileBuffer = null;
      //  Validate buffer exists before attempting upload
      if (!currentFile.LocalFileBuffer || currentFile.LocalFileBuffer.byteLength === 0) {
        await this.idbservice.deleteImageByFileName(currentFile.fileName, currentFile.taskId, currentFile.orgid)
        await this.idbservice.deleteMetaDataByFileName(currentFile.fileName, currentFile.taskId, currentFile.orgid, 'inActive');
        this._appServices.logsActivity(
          this._appenum.EntityOfLogLevel.Critical,
          `FRONTEND_ALERT LocalFileBuffer is empty or missing for file: ${currentFile?.fileName} — skipping`,
          this.componentName, null, null, undefined, 'autoStartUpload'
        );
        const categoryLabel = currentFile?.photoCategory?.length
          ? currentFile.photoCategory[currentFile.photoCategory.length - 1]
          : 'this';

        // NEW — native AlertController since ionicCustomAlert has no button/callback support
        const alert = await this.alertCtrl.create({
          header: 'Photo Not Saved',
          message: `The ${categoryLabel} photo could not be saved. Please capture it again.`,
          backdropDismiss: false, // forces OK tap instead of dismissing by tapping outside
          buttons: [
            {
              text: 'OK',
              handler: () => {
                // NEW — log the acknowledgment when user taps OK
                this._appServices.logsActivity(
                  this._appenum.EntityOfLogLevel.Info,
                  `User acknowledged recapture prompt — file: ${currentFile?.fileName}, category: ${categoryLabel}`,
                  this.componentName, null, null, undefined, 'autoStartUpload'
                );
              }
            }
          ]
        });
        await alert.present();
        await this.moveToNextFile(index, InspectionFileData, taskId);
        return;
      }

      //  ArrayBuffer → File directly, no base64 decode
      const safeFile = new File(
        [currentFile.LocalFileBuffer],
        currentFile.fileName,
        { type: currentFile.LocalFileMime || 'image/jpeg' }
      );
      // InspectionFileData[index].LocalFileBuffer = null;
      const params = {
        fileType: currentFile.fileType,
        taskId: currentFile.taskId,
        status: '1',
        note: `${currentFile.taskId}${currentFile.fileType}`,
        metadata: currentFile.MetaData
      };

      const uploadFormData = new FormData();
      uploadFormData.append('file', safeFile);
      uploadFormData.append(
        'data',
        JSON.stringify(this._appServices.encryptDataValues(JSON.stringify(params)))
      );

      await this.idbservice.updateHitCount(currentFile, hitCount);

      const fileUploadStatus: any = await this._appServices.UploadByPromise(environment.endpoint.fileUpload, uploadFormData);
      console.log("fileUploadStatus", fileUploadStatus)
      const result: any = fileUploadStatus.body;
      this._UploadResponse = this._appServices.decryptDataValues(result.data);

      const httpLog = {
        method: 'POST',
        url: 'fileUpload',
        payLoad: params,
        response: {
          responseCode: this._UploadResponse.StatusCode,
          responseMsg: this._UploadResponse?.Message ?? '',
          result: this._UploadResponse
        }
      };

      console.log("this._UploadResponse", this._UploadResponse)
      if (this._UploadResponse.StatusCode == 200) {
        InspectionFileData[index].LocalFileBuffer = null;
        this._appServices.logsActivity(
          this._appenum.EntityOfLogLevel.Info,
          `Upload success — file: ${currentFile?.fileName}, taskId: ${taskId}`,
          this.componentName, httpLog, null
        );

        await this.idbservice.updateFileDetails(currentFile, this._UploadResponse);
        await this.uploadMetaData(currentFile, this._UploadResponse);
        await this.moveToNextFile(index, InspectionFileData, taskId);
      } else {
        this._appServices.logsActivity(
          this._appenum.EntityOfLogLevel.Critical,
          `FRONTEND_ALERT Upload returned non-200 — file: ${currentFile?.fileName}, code: ${this._UploadResponse.StatusCode}`,
          this.componentName, httpLog, null,
          environment.endpoint.fileUpload
        );
        this.isdataSync.next(false);
        setTimeout(() => {
          this.autoRetrytoUpload(index, InspectionFileData, taskId, hitCount);
        }, this.retryDelay);
      }

    } catch (err: any) {
      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Critical,
        `FRONTEND_ALERT Upload exception — file: ${currentFile?.fileName}, attempt: ${hitCount}, error: ${err?.message || err}`,
        this.componentName,
        {
          method: 'POST',
          url: 'fileUpload',
          response: { responseCode: err?.status ?? 0, responseMsg: err?.message, result: err }
        },
        null,
        environment.endpoint.fileUpload
      );
      this.isdataSync.next(false);
      setTimeout(() => {
        this.autoRetrytoUpload(index, InspectionFileData, taskId, hitCount);
      }, this.retryDelay);
    }
  }

  async autoRetrytoUpload(
    index: number,
    InspectionFileData: any[],
    taskId: string,
    hitCount: number
  ): Promise<void> {
    hitCount = hitCount + 1;

    if (hitCount <= this._appServices.UploadMaxRetryHit) {
      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Info,
        `Retrying upload — file: ${InspectionFileData[index]?.fileName}, attempt: ${hitCount} of ${this._appServices.UploadMaxRetryHit}`,
        this.componentName, null, null
      );
      await this.autoStartUpload(index, InspectionFileData, taskId, hitCount);
    } else {
      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Info,
        `Max retries reached for file: ${InspectionFileData[index]?.fileName} — moving to next file`,
        this.componentName, null, null
      );
      const currentFile = InspectionFileData[index]
      await this.idbservice.fileStatusChange(currentFile, 'false');
      await this.moveToNextFile(index, InspectionFileData, taskId);
    }
  }

  // keeps index progression in one place
  private async moveToNextFile(
    index: number,
    InspectionFileData: any[],
    taskId: string
  ): Promise<void> {
    const nextIndex = index + 1;

    if (nextIndex < InspectionFileData.length) {
      // More files in current batch — continue with next index
      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Info,
        `Moving to next file — ${nextIndex + 1} of ${InspectionFileData.length} | file: ${InspectionFileData[nextIndex]?.fileName}`,
        this.componentName, null, null
      );
      await this.autoStartUpload(nextIndex, InspectionFileData, taskId, 1); //reset hitCount per file
    } else {
      // Current batch fully processed — re-query IndexedDB for any
      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Info,
        `Batch complete — all ${InspectionFileData.length} file(s) processed for taskId: ${taskId}.`,
        this.componentName, null, null
      );
    }
  }

  // async uploadMetaData(MetaDetails, uploadFileDetails) {
  //   const item = this._tempDynamicFormConfig.serverData
  //     .flatMap(data => data.templateJson) // merge all templateJson arrays
  //     .find(item => item.controlName === MetaDetails.controlName);
  //   console.log("roofLineItem", item);
  //   const postJson = {
  //     taskId: MetaDetails.taskId,
  //     serverFileName: uploadFileDetails.Data[0].serverFileName,
  //     controlId: MetaDetails.controlName,
  //     observationText: MetaDetails.ObservationText,
  //     metaTags: JSON.parse(MetaDetails.metaTags),
  //     fileName: MetaDetails.fileName,
  //     localFileUrl: '',
  //     serverFileUrl: '',
  //     fileType: MetaDetails.fileType,
  //     zone: MetaDetails.zone,
  //     photoCategory: MetaDetails.photoCategory,
  //     originalFileName: MetaDetails.originalFileName,
  //     aiTypeId: item?.aiTypeId ? item?.aiTypeId : null
  //   };
  //   const logRequest: any = {
  //     apiEndUrl: environment.endpoint.fileMeteDataUpload,
  //     reqBody: postJson,
  //   };
  //   return this._appServices.postDataWithPromise(environment.endpoint.fileMeteDataUpload, postJson).then(async (res) => {
  //     this.loggingService.handleResponseLog(
  //       res.StatusCode == 200 ? 'info' : 'critical',
  //       logRequest,
  //       res.StatusCode,
  //       res.Message,
  //       `${res.StatusCode != 200 ? 'FRONTEND_ALERT ' : ''} fileMeteDataUpload Api Call`,
  //       this.componentName,
  //       environment.endpoint.fileMeteDataUpload
  //     );
  //     if (res.StatusCode == 200) {
  //       this.takenPhotoMessage = this._translateService.instant('common_text.taken_media_message');
  //       this._appServices.presentToast(this.takenPhotoMessage)
  //       await this.idbservice.updateMetaFileDetails(MetaDetails, true);
  //       this.isdataSync.next(true);
  //       setTimeout(() => {
  //         this.isdataSync.next(false);
  //       }, 2000)
  //     } else {
  //       await this.idbservice.deleteImageByFileName(MetaDetails.fileName, MetaDetails.taskId, MetaDetails.orgid)
  //       await this.idbservice.deleteMetaDataByFileName(MetaDetails.fileName, MetaDetails.taskId, MetaDetails.orgid, 'inActive');
  //       await this.showRecaptureAlert(MetaDetails);
  //       this.isdataSync.next(false);
  //     }
  //   }, async (err) => {
  //     await this.showRecaptureAlert(MetaDetails);
  //     this.loggingService.logApiError(
  //       'critical',
  //       logRequest,
  //       err,
  //       'FRONTEND_ALERT fileMeteDataUpload Api Call',
  //       this.componentName,
  //       environment.endpoint.fileMeteDataUpload
  //     )
  //   })
  // }

  async uploadMetaData(MetaDetails, uploadFileDetails) {
    const item = this._tempDynamicFormConfig.serverData
      .flatMap(data => data.templateJson)
      .find(item => item.controlName === MetaDetails.controlName);
    const postJson = {
      taskId: MetaDetails.taskId,
      serverFileName: uploadFileDetails.Data[0].serverFileName,
      controlId: MetaDetails.controlName,
      observationText: MetaDetails.ObservationText,
      metaTags: JSON.parse(MetaDetails.metaTags),
      fileName: MetaDetails.fileName,
      localFileUrl: '',
      serverFileUrl: '',
      fileType: MetaDetails.fileType,
      zone: MetaDetails.zone,
      photoCategory: MetaDetails.photoCategory,
      originalFileName: MetaDetails.originalFileName,
      aiTypeId: item?.aiTypeId ? item?.aiTypeId : null
    };

    const logRequest: any = {
      apiEndUrl: environment.endpoint.fileMeteDataUpload,
      reqBody: postJson,
    };
    const MAX_ATTEMPTS = 3;
    const RETRY_DELAY_MS = 1500;
    let lastResponse: any = null;
    let lastError: any = null;
    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      try {
        const res = await this._appServices.postDataWithPromise(environment.endpoint.fileMeteDataUpload, postJson);
        this.loggingService.handleResponseLog(
          res.StatusCode == 200 ? 'info' : 'critical',
          logRequest,
          res.StatusCode,
          res.Message,
          `${res.StatusCode != 200 ? 'FRONTEND_ALERT ' : ''} fileMeteDataUpload Api Call (attempt ${attempt}/${MAX_ATTEMPTS})`,
          this.componentName,
          environment.endpoint.fileMeteDataUpload
        );

        if (res.StatusCode == 200) {
          // Success — handle and exit immediately, no further retries needed
          this.takenPhotoMessage = this._translateService.instant('common_text.taken_media_message');
          this._appServices.presentToast(this.takenPhotoMessage);
          await this.idbservice.updateMetaFileDetails(MetaDetails, true);
          this.isdataSync.next(true);
          setTimeout(() => {
            this.isdataSync.next(false);
          }, 2000);
          return; // done — success path exits the function entirely
        }

        // Non-200 response — remember it, retry if attempts remain
        lastResponse = res;

        if (attempt < MAX_ATTEMPTS) {
          await this.delay(RETRY_DELAY_MS);
          continue; // explicit: go back to top of loop, try again
        }

      } catch (err) {
        // Network/exception error — remember it, retry if attempts remain
        lastError = err;
        this.loggingService.logApiError(
          'critical',
          logRequest,
          err,
          `FRONTEND_ALERT fileMeteDataUpload Api Call (attempt ${attempt}/${MAX_ATTEMPTS})`,
          this.componentName,
          environment.endpoint.fileMeteDataUpload
        );
        if (attempt < MAX_ATTEMPTS) {
          await this.delay(RETRY_DELAY_MS);
          continue; // explicit: go back to top of loop, try again after an exception too
        }
      }
    }

    // All attempts exhausted (whether by bad status, thrown errors, or a mix) — run failure path
    console.log('uploadMetaData: all attempts exhausted', { lastResponse, lastError });
    await this.idbservice.deleteImageByFileName(MetaDetails.fileName, MetaDetails.taskId, MetaDetails.orgid);
    await this.idbservice.deleteMetaDataByFileName(MetaDetails.fileName, MetaDetails.taskId, MetaDetails.orgid, 'inActive');
    await this.showRecaptureAlert(MetaDetails);
    this.isdataSync.next(false);
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async showRecaptureAlert(currentFile: any): Promise<void> {
    const categoryLabel = currentFile?.photoCategory?.length
      ? currentFile.photoCategory[currentFile.photoCategory.length - 1]
      : 'this';
    // NEW — native AlertController since ionicCustomAlert has no button/callback support
    const alert = await this.alertCtrl.create({
      header: 'Photo Not Saved',
      message: `The ${categoryLabel} photo could not be saved. Please capture it again.`,
      backdropDismiss: false, // forces OK tap instead of dismissing by tapping outside
      buttons: [
        {
          text: 'OK',
          handler: () => {
            // NEW — log the acknowledgment when user taps OK
            this._appServices.logsActivity(
              this._appenum.EntityOfLogLevel.Info,
              `User acknowledged recapture prompt — file: ${currentFile?.fileName}, category: ${categoryLabel}`,
              this.componentName, null, null, undefined, 'uploadMetaData'
            );
          }
        }
      ]
    });
    await alert.present();
  }
  async finalupdateFormJson(taskId) {
    this.encryptionService.sessionstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.isRunningAsyncUtility, 'false')
  }

  // address Async File Upload
  async uploadAddressTaskFiles(taskId) {
    var TaskInspectionAddress: any = await this.idbservice.getAddressTaskFileDetails(taskId);
    if (TaskInspectionAddress.length > 0) {
      await this.fileTransferFromFileSystem(TaskInspectionAddress[0]);
    }
  }
  async fileTransferFromFileSystem(TaskInspectionAddress) {
    try {
      const isValidToken = await this._appServices.checkTokenExpired();
      console.log("isValidToken", isValidToken)
      const params = {
        fileType: TaskInspectionAddress.FileType,
        taskId: TaskInspectionAddress.taskId,
        status: "1",
        note: TaskInspectionAddress.taskId + TaskInspectionAddress.FileType,
        metadata: TaskInspectionAddress.MetaData
      };
      console.log("post Json of address image", params);

      // ArrayBuffer -> Blob -> File
      const mimeType = TaskInspectionAddress.MimeType || 'image/jpeg';
      const safeBlob = new Blob([TaskInspectionAddress.buffer], { type: mimeType });
      const safeFile = new File([safeBlob], TaskInspectionAddress.FileName, { type: mimeType });

      const uploadFormData = new FormData();
      uploadFormData.append('file', safeFile);
      uploadFormData.append('data', JSON.stringify(this._appServices.encryptDataValues(JSON.stringify(params))));

      const testObj = {
        fileType: TaskInspectionAddress.FileType,
        taskId: TaskInspectionAddress.taskId,
        status: "1",
        note: TaskInspectionAddress.taskId + TaskInspectionAddress.FileType,
        metadata: TaskInspectionAddress.MetaData,
        fileName: TaskInspectionAddress.FileName,
        blobSize: safeFile.size
      };

      const fileUploadStatus = await this._appServices.UploadByPromise(environment.endpoint.fileUpload, uploadFormData);
      const result: any = fileUploadStatus.body;
      const _UploadResponse = this._appServices.decryptDataValues(result.data);
      console.log("_UploadResponse", _UploadResponse);

      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'fileUpload',
          payLoad: testObj,
          response: {
            responseCode: _UploadResponse.StatusCode,
            responseMsg: _UploadResponse.StatusCode.Message,
            result: _UploadResponse
          },
        },
        taskDetails: null
      }
      this._appServices.logsActivity(
        _UploadResponse.StatusCode != 200
          ? this._appenum.EntityOfLogLevel.Critical
          : this._appenum.EntityOfLogLevel.Info,
        `${_UploadResponse.StatusCode != 200 ? 'FRONTEND_ALERT ' : ''} FileUpload For Address Image`,
        this.componentName,
        paramRequest.httpRequest,
        paramRequest.taskDetails,
        environment.endpoint.fileUpload
      );

      if (_UploadResponse.StatusCode == 200) {
        await this.idbservice.updateAddressFileDetails(TaskInspectionAddress, _UploadResponse);
        setTimeout(() => {
          this.uploadAddressTaskFiles(TaskInspectionAddress.taskId);
        }, 2000);
        return;
      } else if ([401, 404, 405].includes(_UploadResponse.StatusCode)) {
        this._appServices.presentToast(_UploadResponse.Message);
        await this.idbservice.updateAddressFileDetailsErrorCase(TaskInspectionAddress, 'error');
        this._nav.navigateRoot(['verify-otp']);
        window.location.reload();
        return;
      } else {
        await this.idbservice.updateAddressFileDetailsErrorCase(TaskInspectionAddress, 'error');
        throw new Error('Non-retryable upload failure');
      }

    } catch (err) {
      const testObj = {
        file: null,
        fileType: TaskInspectionAddress.FileType,
        taskId: TaskInspectionAddress.taskId,
        status: "1",
        note: TaskInspectionAddress.taskId + TaskInspectionAddress.FileType,
        metadata: TaskInspectionAddress.MetaData,
        fileName: TaskInspectionAddress.FileName,
        blobSize: 0
      };

      const paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'fileUpload',
          payLoad: testObj,
          response: {
            responseCode: err?.status || 500,
            responseMsg: err?.message || 'Unknown error',
            result: err
          }
        },
        taskDetails: null
      };

      this._appServices.logsActivity(
        this._appenum.EntityOfLogLevel.Critical,
        'FRONTEND_ALERT FileUpload For Address Image',
        this.componentName,
        paramRequest.httpRequest,
        paramRequest.taskDetails,
        environment.endpoint.fileUpload
      );
      throw err;
    }
  }
}
